// Meta Pixel configuration — initialized once in index.tsx (see utils/metaPixel.ts).
// Only PageView is sent from this landing. InitiateCheckout and Purchase are handled by ImpulTienda.
// Checkout buttons carry data-cta="checkout" for reference.
export const metaPixel = {
  id: "1452389940323197",
  enabled: true,
  // Pixel only fires on these hostnames, so previews and test environments don't send PageViews.
  allowedHosts: ["faithfoundations.ideasyrecursos.com", "www.faithfoundations.ideasyrecursos.com"],
};
